<template>
	<dl :class="{
		'im-section': true,
		'msg-list-container': true,
		'disabled': !conversationList.length,
		'nodata': !((conversationList.find(o => o.id == currentSessionId) || {}).data || []).length,
		'load-msg': $store.state.msgLoadStatus
	}">
		<dt class="head">
			<template v-if="!currentSessionId">--没有会话--</template>
			<template v-else>{{ (conversationList.find(o => o.id == currentSessionId) || {}).clientNickName || '[未知用户]' }}</template>
		</dt>

		<dd>
			<msgList></msgList>
			<aiAnswer @sendMsg="sendAiAnswerMsg"></aiAnswer>
			<sendMsg ref="sendMsg" @closeSession="closeSession"></sendMsg>
		</dd>
	</dl>
</template>

<script>
import msgList from './msgList.vue'
import sendMsg from './sendMsg.vue'
import aiAnswer from './aiAnswer.vue'
export default {
	name: 'msgListContainer',
	data () {
		return {}
	},
	components: {
		'msgList': msgList,
		'sendMsg': sendMsg,
		'aiAnswer': aiAnswer
	},
	computed: {
		conversationList () {
			return this.$store.state.conversationList;
		},
		currentSessionId () {
			return this.$store.state.currentSessionId;
		}
	},
	methods: {
		// 发送AI智能辅助内容
		sendAiAnswerMsg (html, param, callback) {
			var self = this;
			self.$refs.sendMsg.sendMessage(html, param, callback);
		},

		// 关闭会话
		closeSession (sessionId, needRts) {
			var self = this;
			self.$emit('closeSession', sessionId, needRts);
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/msgList/msgListContainer.vue